"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'For Each',
    description: 'Run following nodes for each item in a list',
});
//# sourceMappingURL=for-each.js.map